var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ActionTypes } from './actions';
var defaultFieldState = function (value) { return ({
    value: value,
    error: '',
    isValid: false,
    isDirty: false,
}); };
var defaultIntlPhoneNumberValue = {
    phoneNumber: '',
    country: null,
};
export var initialState = {
    firstName: defaultFieldState(''),
    lastName: defaultFieldState(''),
    emailAddress: defaultFieldState(''),
    intlPhoneNumber: defaultFieldState(defaultIntlPhoneNumberValue),
    questions: defaultFieldState(''),
};
export var personalDetails = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.HANDLE_INPUT: {
            return __assign(__assign({}, state), (_a = {}, _a[action.payload.field] = __assign(__assign({}, state[action.payload.field]), action.payload.input), _a));
        }
        case ActionTypes.SET_FIELD_DIRTY:
            return __assign(__assign({}, state), (_b = {}, _b[action.payload.field] = __assign(__assign({}, state[action.payload.field]), { isDirty: true }), _b));
        default:
            return state;
    }
};
